import { render, staticRenderFns } from "./basicForm.vue?vue&type=template&id=3cb47160"
import script from "./basicForm.vue?vue&type=script&lang=js"
export * from "./basicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb47160')) {
      api.createRecord('3cb47160', component.options)
    } else {
      api.reload('3cb47160', component.options)
    }
    module.hot.accept("./basicForm.vue?vue&type=template&id=3cb47160", function () {
      api.rerender('3cb47160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/feesPayable/component/AddFeee/basicForm.vue"
export default component.exports